import { appendGuidedSearchTrackingToUrl } from "../../../../helpers/guidedSearchTracking";

export const MIN_VISUAL_REFINEMENTS_COUNT = 4;

const EMPTY_ARRAY = [];

const normaliseImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return null;
  }

  if (/^https?:\/\//i.test(imageUrl)) {
    return imageUrl;
  }

  return `https://${imageUrl}`;
};

const buildSearchLinkUrl = (searchTerm, sourceSearchTerm) => {
  const linkUrl = `/search/?${new URLSearchParams({ q: searchTerm }).toString()}`;

  return appendGuidedSearchTrackingToUrl({
    linkUrl,
    sourceSearchTerm,
    destinationSearchTerm: searchTerm,
  }).linkUrl;
};

const normalisePreviewImageUrls = ({ imageUrls } = {}) =>
  Array.isArray(imageUrls)
    ? imageUrls.map(normaliseImageUrl).filter(Boolean)
    : [];

const normaliseVisualRefinement = (
  { id, displayName, preview, consequence = {} } = {},
  sourceSearchTerm,
) => {
  const imageUrls = normalisePreviewImageUrls(preview);
  const imageUrl = imageUrls[0];
  const searchTerm = consequence.searchTerm;

  if (!id || !displayName || !searchTerm || !imageUrl) {
    return null;
  }

  return {
    selectionKey: id,
    name: displayName,
    imageUrl,
    imageUrls,
    linkUrl: buildSearchLinkUrl(searchTerm, sourceSearchTerm),
  };
};

export const normaliseVisualRefinements = (
  visualRefinementsData,
  sourceSearchTerm,
) => {
  const visualRefinements = visualRefinementsData?.visualRefinements;

  if (!Array.isArray(visualRefinements)) {
    return EMPTY_ARRAY;
  }

  const categories = visualRefinements
    .map((refinement) =>
      normaliseVisualRefinement(refinement, sourceSearchTerm),
    )
    .filter(Boolean);

  return categories.length >= MIN_VISUAL_REFINEMENTS_COUNT
    ? categories
    : EMPTY_ARRAY;
};

export const hasRenderableGuidedSearch = (visualRefinementsData) =>
  normaliseVisualRefinements(visualRefinementsData, "").length > 0;
